import { IconFileType, Pagination } from '@app/components/index'
import { usePaymentReports } from '@app/lib'
import { ActionIcon, Box, createStyles, LoadingOverlay, Paper, type PaperProps, Table } from '@mantine/core'
import { IconDownload } from '@tabler/icons-react'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { map } from 'lodash'
import { type FC, useState } from 'react'

dayjs.extend(relativeTime)

const useStyles = createStyles(() => ({
  actionColumn: {
    textAlign: 'center',
    verticalAlign: 'center',
    width: 64
  },
  typeColumn: {
    textAlign: 'center',
    verticalAlign: 'center',
    width: 50
  }
}))

export interface PaymentReportsTableProps extends Omit<PaperProps, 'children'> {}

export const PaymentReportsTable: FC<PaymentReportsTableProps> = (props) => {
  const [page, setPage] = useState(1)
  const { data: paymentReports, isFetching: isFetchingPaymentReports } = usePaymentReports(page)
  const { classes, theme } = useStyles()

  return (
    <Paper
      p='lg'
      {...props}
    >
      <Box pos='relative'>
        <LoadingOverlay visible={isFetchingPaymentReports} />
        <Table
          mb='xl'
          horizontalSpacing='xs'
          verticalSpacing='xs'
        >
          <thead>
            <tr>
              <th className={classes.typeColumn}>Type</th>
              <th>Name</th>
              <th className={classes.actionColumn}>Action</th>
            </tr>
          </thead>
          <tbody>
            {map(paymentReports?.data, (paymentReport, paymentReportIdx) => (
              <tr key={`paymentReport-${paymentReportIdx}`}>
                <td className={classes.typeColumn}>
                  <IconFileType
                    color={theme.colors.navy[6]}
                    fileExt={paymentReport.fileExt}
                  />
                </td>
                <td>{paymentReport.reportDisplayName}</td>
                <td className={classes.actionColumn}>
                  <ActionIcon
                    color='navy'
                    component='a'
                    href={`/api/payment-reports/${paymentReport.id}`}
                    tabIndex={0}
                    title='Download Payment Report'
                    variant='transparent'
                  >
                    <IconDownload size={16} />
                  </ActionIcon>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Pagination
          onChange={setPage}
          total={paymentReports?.pagination?.totalPages || 1}
          value={page}
        />
      </Box>
    </Paper>
  )
}
